import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import shamirLogo from "../images/headings/shamir-logo.svg";
import straingeBeastLogo from "../images/headings/straingeBeast-logo.svg";
import close from "../images/headings/close.svg";

const Modal = ({ modal, toggleModal, modalContent, toggleScroll }) => {
  return modal ? (
    <div className="modal" aria-modal="true" role="dialog">
      <div className="modal__inner">
        <button
          className="modal__close"
          onClick={() => {
            toggleModal(false);
            toggleScroll(`auto`);
          }}
          title="Close Modal"
        >
          <img src={close} alt="Close" />
        </button>
        {modalContent === "shamir" ? <Shamir /> : null}
        {modalContent === "straingeBeast" ? <StraingeBeast /> : null}
      </div>
    </div>
  ) : null;
};

const Shamir = () => (
  <>
    <h2 className="modal__title">
      <img src={shamirLogo} alt="Shamir" />
    </h2>
    <StaticImage
      className="modal__image"
      src="../images/modal/shamir-press-photo-1.jpg"
      alt="Shamir Press Photo 1"
    />
    <p>
      Shamir is a Philadelphia-based artist best known for confessional lyricism
      and an expressive countertenor delivery. Hailing from the Northtown area
      of Las Vegas, he has been on a long, six-year journey to craft an album
      that matched his vision. With flashes of synth, punctuated drum beats and
      ‘90s post-hardcore self-awareness, his seventh full-length release Shamir
      is an intimately crafted manifestation of his journey to artistic
      realization.
    </p>
    <p>
      Between producing a Buzzsession with him last fall and naming “On My Own”
      as one of our Top 100 Songs of 2020, it’s safe to say we at The Wild Honey
      Pie are big fans of Shamir’s eclectic DIY genre-blending, as well as his
      message of promoting mental health awareness. Like the butterfly he has
      adopted as his iconography, Shamir is floating, and makes you feel like
      you are, too.
    </p>
    <iframe
      title="Shamir"
      className="modal__embed"
      src="https://open.spotify.com/embed/track/07yXm3rSwpfSFwRu3QpTdA"
      width="300"
      height="380"
      frameBorder="0"
      allowtransparency="true"
      allow="encrypted-media"
    ></iframe>
  </>
);

const StraingeBeast = () => (
  <>
    <h2 className="modal__title modal__title--strainge-beast">
      <img src={straingeBeastLogo} alt="Strainge Beast" />
    </h2>
    <div className="modal__content">
      <StaticImage
        className="modal__image modal__image--straigne-beast"
        src="../images/modal/strainge-beast-press.jpg"
        alt="Strainge Beast Drink"
      />
      <div className="modal__copy">
        <p>
          Our friends at Strainge Beast Hard Kombucha set out on a journey to
          find the best ingredients, capture the wildest cultures and explore
          the tastiest yeasts. They adventured every orchard, every field, and
          left no SCOBY unturned until they held the perfect harvest. You’ll
          notice from your first sip the care they put into crafting this
          Strainge Beast Hard Kombucha, and we’re proud to bring you a taste of
          their playful blooms, tropic songs and wafting herbs.
        </p>
        <p>
          <a
            href="https://instagram.com/straingebeast"
            target="_blank"
            title="Follow Strainge Beast"
          >
            Follow Strainge Beast Hard Kombucha for more details
          </a>
        </p>
      </div>
    </div>
  </>
);

export default Modal;
